import { MapReportApi } from '@/api/MapReportApi'
import { MapReportModel } from '@/models/MapReport/MapReportModel'

export class MapReportRepository {
  static async create(form, advertiserId) {
    await MapReportApi.create(form, Number(advertiserId))
  }

  static async findById(mapReportId, advertiserId) {
    const mapReport = await MapReportApi.findById(
      Number(mapReportId),
      Number(advertiserId),
    )
    if (mapReport) {
      return MapReportModel.assign(mapReport.item)
    } else {
      return undefined
    }
  }

  static async findByIdForAdmin(mapReportId) {
    const mapReport = await MapReportApi.findByIdForAdmin(Number(mapReportId))
    return MapReportModel.assign(mapReport.item)
  }
}
